module.exports = "/packs/media/images/outcome-spending-4512394d68f225d1844420fd64e4a3bd.png";